import { useContext, useState, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { CompanyDetailQuery } from 'interfaceAdapter/queries/CompanyDetail';
import { IBuyerDetailAfterMatch } from 'domain/entities/Buyer/Buyer';
import { useParams } from 'react-router-dom';
import { agentUserContext } from 'application/contexts/useAgentUser';
import { useLoading } from 'application/contexts/useLoading';
import { IAreaOption } from 'domain/entities/Buyer/Buyer';
import { BuyerRegistrationProfileInfoQuery } from 'interfaceAdapter/queries/BuyerRegistrationProfileInfo';

export const useBuyerDetailAfterMatch = () => {
    const diContainer = useContext(diContainerContext);
    const companyDetailQuery = diContainer.resolve(CompanyDetailQuery);
    const buyerRegistrationProfileInfoQuery = diContainer.resolve(BuyerRegistrationProfileInfoQuery);
    const { loading, setLoading } = useLoading();
    const [buyer, setBuyer] = useState<IBuyerDetailAfterMatch>();
    const { user } = useContext(agentUserContext);
    const [areaChoices, setAreaChoices] = useState<IAreaOption[]>([]);
    const [employeeLowerChoices, setEmployeeLowerChoices] = useState<string[][]>([]);
    const [employeeUpperChoices, setEmployeeUpperChoices] = useState<string[][]>([]);
    const [revenueScaleLowerChoices, setRevenueScaleLowerChoices] = useState<string[][]>([]);
    const [revenueScaleUpperChoices, setRevenueScaleUpperChoices] = useState<string[][]>([]);
    const [purchaseAmountLowerChoices, setPurchaseAmountLowerChoices] = useState<string[][]>([]);
    const [purchaseAmountUpperChoices, setPurchaseAmountUpperChoices] = useState<string[][]>([]);
    const [industryChoices, setIndustryChoices] = useState<string[][]>([]);
    const [profitLevelLowerChoices, setProfitLevelLowerChoices] = useState<string[][]>([]);
    const [profitLevelUpperChoices, setProfitLevelUpperChoices] = useState<string[][]>([]);
    const [netAssetsLevelLowerChoices, setNetAssetsLevelLowerChoices] = useState<string[][]>([]);
    const [netAssetsLevelUpperChoices, setNetAssetsLevelUpperChoices] = useState<string[][]>([]);
    const [employeeChoices, setEmployeeChoices] = useState<string[][]>([]);
    const [revenueChoices, setRevenueChoices] = useState<string[][]>([]);
    const params = useParams();

    useEffect(() => {
        if (params.buyer_id === undefined) {
            return;
        }

        const fetchData = async () => {
            setLoading(true);
            try {
                const resBuyer = await companyDetailQuery.fetchBuyerDetail(Number(params.buyer_id));
                setBuyer(resBuyer);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const fetchChoices = async () => {
            try {
                const data = await buyerRegistrationProfileInfoQuery.fetch();
                setAreaChoices(data.area_choices);
                setEmployeeChoices(data.employee_choices);
                setRevenueChoices(data.revenue_choices);
                setEmployeeLowerChoices(data.employee_lower_choices);
                setEmployeeUpperChoices(data.employee_upper_choices);
                setRevenueScaleLowerChoices(data.revenue_scale_lower_choices);
                setRevenueScaleUpperChoices(data.revenue_scale_upper_choices);
                setPurchaseAmountLowerChoices(data.purchase_amount_lower_choices);
                setPurchaseAmountUpperChoices(data.purchase_amount_upper_choices);
                setIndustryChoices(data.industry_choices);
                setProfitLevelLowerChoices(data.profit_level_lower_choices);
                setProfitLevelUpperChoices(data.profit_level_upper_choices);
                setNetAssetsLevelLowerChoices(data.net_assets_level_lower_choices);
                setNetAssetsLevelUpperChoices(data.net_assets_level_upper_choices);
                setProfitLevelLowerChoices(data.profit_level_lower_choices);
                setProfitLevelUpperChoices(data.profit_level_upper_choices);
            } catch (error) {
                console.error('Failed to fetch choices:', error);
            }
        };
        fetchChoices();
    }, []);

    return {
        user,
        loading,
        buyer,
        employeeLowerChoices,
        employeeUpperChoices,
        revenueScaleLowerChoices,
        revenueScaleUpperChoices,
        purchaseAmountLowerChoices,
        purchaseAmountUpperChoices,
        profitLevelLowerChoices,
        profitLevelUpperChoices,
        netAssetsLevelLowerChoices,
        netAssetsLevelUpperChoices,
        industryChoices,
        areaChoices,
        employeeChoices,
        revenueChoices,
    };
};
